import { render, staticRenderFns } from "./CorrectiveActionView.vue?vue&type=template&id=5e555d34"
import script from "./CorrectiveActionView.vue?vue&type=script&lang=js"
export * from "./CorrectiveActionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports